var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.271,
    height: 25.501,
    viewBox: "0 0 22.271 25.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attendance",
    transform: "translate(-8.148 -1.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(8.899 2.485)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 4.545,
    cy: 4.545,
    r: 4.545,
    transform: "translate(4.07 2.91)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M27.618,2.488A2.16,2.16,0,0,0,25.35,4.63V5.949c.076,4.623-.935,7.957-2.9,9.6-.252.2-.5.4-.782.606a7.377,7.377,0,0,1-4.168,1.26,7.464,7.464,0,0,1-4.749-1.692A6.2,6.2,0,0,0,8.9,21.585V25.4a1.079,1.079,0,0,0,1.086,1.086H25.041A1.079,1.079,0,0,0,26.127,25.4V21.585a3.906,3.906,0,0,0-.025-.556,6.881,6.881,0,0,1,1.086-4.345c1.717-2.577,2.552-6.188,2.476-10.735V4.787A2.268,2.268,0,0,0,27.618,2.488Z",
    transform: "translate(-8.899 -2.485)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.227d15452f9559d3bd577001e08713c1.svg";
export { ForwardRef as ReactComponent };